/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "inventory": {
        "nested": {
          "inventory_common": {
            "nested": {
              "InventoryType": {
                "values": {
                  "DO_NOT_USE_INVENTORY_TYPE": 0,
                  "INVENTORY": 1,
                  "SALES_LIMIT": 2
                }
              },
              "ComposedObjectType": {
                "values": {
                  "INVALID_COMPOSITION_TYPE": 0,
                  "BUNDLE": 1,
                  "STOCK_CONVERSION": 2,
                  "RECIPE": 3
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.inventory?.nested?.inventory_common?.nested?.InventoryType && !$root.nested?.squareup?.nested?.inventory?.nested?.inventory_common?.nested?.ComposedObjectType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE InventoryType @ squareup/inventory/common.proto at 23:1
 */
export const InventoryType = $root.lookupEnum('squareup.inventory.inventory_common.InventoryType').values;
/**
 * SOURCE ComposedObjectType @ squareup/inventory/common.proto at 37:1
 */
export const ComposedObjectType = $root.lookupEnum('squareup.inventory.inventory_common.ComposedObjectType').values;